import { Flex } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Input, Modal, Toast } from '@common-web';
import { BASE_PATH } from '@constants/seller-center-paths.js';
import { findQuickLink } from '../../helper';
import styles from './index.module.scss';
import cx from 'clsx';
import { MdClose } from 'react-icons/md';
import { setQuickLinks } from '@reducers/quick-links-slice/index.js';
import { deleteQuickLinkApi } from '@apis/seller-center/quick-links.js';
import { getErrorString } from '@utils/utils.js';

const QuickLinkChips = ({ editEnabled = false, quickLinks = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [input, setInput] = useState('');
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(null);
  const [selectedChip, setSelectedChip] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    setSelectedChip(findQuickLink({ location, quickLinks }));
  }, [location]);

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      const chipId = deleteModal.id;
      await deleteQuickLinkApi(deleteModal.id);
      dispatch(setQuickLinks(quickLinks.filter((link) => link.id !== chipId)));
      setDeleteModal(null);
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
      {quickLinks?.map((chip) => {
        return (
          <Button
            key={chip.id}
            onClick={() => {
              const link = chip.link.split('?');
              const path = link[0].replace(BASE_PATH, '');
              const search = `?${link[1]}`;
              navigate({
                pathname: path,
                search: search,
              });
            }}
            className={cx(styles.quickLinkBtn)}
            size={'small'}
            shape={'round'}
            bordered={true}
          >
            {chip.name}
            <Flex
              align="center"
              gap={4}
              className={styles.btnIcons}
              style={{ '--icon-width': '14px', '--icon-count': '1' }}
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              {/* No edit API available */}
              {/* <Flex align={'center'}>
                {editEnabled && (
                  <MdEdit
                    onClick={() => {
                      setInput(chip.name);
                      setEditModal(true);
                    }}
                    size={'var(--icon-width)'}
                  />
                )}
              </Flex> */}
              <MdClose
                className={styles.removeIcon}
                onClick={() => {
                  setDeleteModal(chip);
                }}
              />
            </Flex>
          </Button>
        );
      })}

      <Modal
        title={'Edit Quick Link'}
        open={editModal}
        ModalBody={
          <Input
            placeholder={'Edit'}
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
            }}
          />
        }
        handleCancel={() => {
          setEditModal(false);
        }}
        showActions={true}
        okText="Confirm"
        handleOk={() => {
          setEditModal(false);
          setInput('');
        }}
        destroyOnClose={true}
        width={525}
      />

      <Modal
        title={'Delete Saved Search'}
        open={!!deleteModal}
        handleCancel={() => {
          setDeleteModal(null);
        }}
        okButtonProps={{ loading: deleteLoading }}
        handleOk={handleDelete}
        okText="Delete"
        width={525}
        ModalBody={<p>Are you sure you want to delete {deleteModal?.name}?</p>}
        showActions={true}
        destroyOnClose={true}
      />
    </>
  );
};

export default QuickLinkChips;
